var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSharecomponent = function SvgSharecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 10.56c-.57 0-1.08.225-1.47.577L4.683 8.025c.037-.173.067-.345.067-.525 0-.18-.03-.353-.067-.525L9.97 3.893a2.24 2.24 0 0 0 1.53.607 2.247 2.247 0 0 0 2.25-2.25A2.247 2.247 0 0 0 11.5 0a2.247 2.247 0 0 0-2.25 2.25c0 .18.03.353.068.525L4.03 5.858A2.24 2.24 0 0 0 2.5 5.25 2.247 2.247 0 0 0 .25 7.5 2.247 2.247 0 0 0 2.5 9.75a2.24 2.24 0 0 0 1.53-.607l5.34 3.12c-.037.157-.06.322-.06.487 0 1.207.982 2.19 2.19 2.19 1.207 0 2.19-.982 2.19-2.19 0-1.207-.982-2.19-2.19-2.19Z",
    fill: "current"
  })));
};
export default SvgSharecomponent;